<template>
  <el-table-column :width="$route.path == '/cggl/zjjh_edit'
      ? 200
      : handleDisable
        ? headerWidth
        : this.$parent.$parent.handleWidth
    " align="center" class-name="y-handle" fixed="right">
    <template slot="header" slot-scope="scope">
      {{ handle }}
      <br v-if="headerbr" />
      <i style="margin-left: 10px; cursor: pointer" class="el-icon-upload2"
        @click.stop="$emit('handleImport', { e: $event, scope })" v-if="isExcelImport"></i>
      <i style="margin-left: 10px; cursor: pointer" class="el-icon-download"
        @click.stop="$emit('handleExport', { e: $event, scope })" v-if="isExcelExport"></i>
      <i style="margin-left: 10px; cursor: pointer" class="el-icon-s-tools"
        @click="$emit('handleSettings', { e: $event, scope })" v-if="columnSetting"></i>
    </template>
    <template #default="scope">
      <div class="table-handle" @click.stop="$emit('handleClickHandle', { e: $event, scope })"
        v-show="!scope.row.subtotal">
        <template v-for="(item, index) in handleBT">
          <!-- 审批历史按钮需要显示小红点，其他不显示 -->
          <!-- <el-badge class="dot-item"  :key="'badge'+index + item.key" :is-dot="item.key == 'approvalHistory' && scope.row.newHistoryRecord "> -->
          <template v-if="routePush == '/zcyhgl/ccyhsp'">
            <i :class="item.class" :title="item.title" :val="item.key" style="margin-right: 10px"
              v-if="scope.row.reg_status != '同意' && scope.row.reg_status != '驳回'" :style="item.key === 'configFormula' && scope.row.existCalculateFormula
                  ? 'color:#5cb6ff'
                  : ''
                ">
            </i>
          </template>
          <template v-else-if="
            routePush != '/zcyhgl/ccyhsp' &&
            routePush != '/gpgl/wdgp' &&
            routePush != '/gpgl/wdzp' &&
            routePush != '/gpgl/gpdt' &&
            routePush != '/gpgl/jywj'
          ">
            <i :class="item.class" :title="item.title" :val="item.key" style="margin-right: 10px" :style="item.key === 'configFormula' && scope.row.existCalculateFormula
                ? 'color:#5cb6ff'
                : ''
              ">
            </i>
          </template>
          <template v-else-if="routePush == '/gpgl/wdgp'">
            <template v-if="
              item.key != 'confirmedListing' &&
              item.key != 'cancelListing' &&
              scope.row.contract_status !== '挂牌中'
            ">
              <template v-if="item.key == 'view'">
                <i :class="item.class" :title="item.title" :val="item.key" style="margin-right: 10px" :style="item.key === 'configFormula' && scope.row.existCalculateFormula
                    ? 'color:#5cb6ff'
                    : ''
                  ">
                </i>
              </template>
             
              <template v-if="(!scope.row.contract_status ||scope.row.contract_status === '已取消' )  && (item.key == 'edit' || item.key == 'delete')">
                <i :class="item.class" :title="item.title" :val="item.key" style="margin-right: 10px" :style="item.key === 'configFormula' && scope.row.existCalculateFormula
                    ? 'color:#5cb6ff'
                    : ''
                  ">
                </i>
              </template>
            </template>

            <i :class="item.class" :title="item.title" :val="item.key" style="margin-right: 10px" v-if="
              item.key != 'confirmedListing' &&
              item.key != 'cancelListing' &&
              item.key == 'view' &&
              scope.row.contract_status == '挂牌中'
            " :style="item.key === 'configFormula' && scope.row.existCalculateFormula
                  ? 'color:#5cb6ff'
                  : ''
                ">
            </i>
            <i :class="item.class" :title="item.title" :val="item.key" style="margin-right: 10px" v-if="
              item.key == 'confirmedListing' &&
              (scope.row.contract_status === '已取消' || !scope.row.contract_status)
            " :style="item.key === 'configFormula' && scope.row.existCalculateFormula
                  ? 'color:#5cb6ff'
                  : ''
                ">
            </i>
            <i :class="item.class" :title="item.title" :val="item.key" style="margin-right: 10px"
              v-if="item.key == 'cancelListing' && scope.row.contract_status === '挂牌中'" :style="item.key === 'configFormula' && scope.row.existCalculateFormula
                  ? 'color:#5cb6ff'
                  : ''
                ">
            </i>
          </template>

          <template v-else-if="routePush == '/gpgl/wdzp'">
            <i :class="item.class" :title="item.title" :val="item.key" style="margin-right: 10px"
              v-if="item.key != 'cancelDelisting' && item.key != 'delistedModuleListed'" :style="item.key === 'configFormula' && scope.row.existCalculateFormula
                  ? 'color:#5cb6ff'
                  : ''
                ">
            </i>
            <i :class="item.class" :title="item.title" :val="item.key" style="margin-right: 10px" v-if="
              item.key == 'delistedModuleListed' &&
              scope.row.contract_status !== '已取消' &&
              scope.row.is_completed != '是'
            " :style="item.key === 'configFormula' && scope.row.existCalculateFormula
                  ? 'color:#5cb6ff'
                  : ''
                ">
            </i>
            <i :class="item.class" :title="item.title" :val="item.key" style="margin-right: 10px" v-if="
              item.key == 'cancelDelisting' &&
              scope.row.contract_status !== '已取消' &&
              scope.row.is_completed != '是' && !scope.row.rid
            " :style="item.key === 'configFormula' && scope.row.existCalculateFormula
                  ? 'color:#5cb6ff'
                  : ''
                ">
            </i>
          </template>

          <template v-else-if="routePush == '/gpgl/gpdt'">
            <i :class="item.class" :title="item.title" :val="item.key" style="margin-right: 10px"
              v-if="item.key == 'confirmedDelisting'" :style="item.key === 'configFormula' && scope.row.existCalculateFormula
                  ? 'color:#5cb6ff'
                  : ''
                ">
            </i>
          </template>
          <template v-else-if="routePush == '/gpgl/jywj'">
            <i :class="item.class" :title="item.title" :val="item.key" style="margin-right: 10px"
              v-if="item.key == 'completed' && scope.row.is_completed == '否'" :style="scope.row.valid_data == '无效' ? 'pointer-events: none;color: red' : ''
                ">
            </i>
            <i :class="item.class" :title="item.title" :val="item.key" style="margin-right: 10px"
              v-if="item.key == 'closingManagement'" :style="item.key === 'configFormula' && scope.row.existCalculateFormula ? 'color:#5cb6ff' : ''">
            </i>
            <i :class="item.class" :title="item.title" :val="item.key" style="margin-right: 10px"
              v-if="item.key == 'print'">
            </i>
          </template>
          <!-- </el-badge> -->
        </template>
      </div>
    </template>
  </el-table-column>
</template>
<script>
import { getSession } from "@/utils/methods";
export default {
  name: "Y-table-Handle",
  props: {
    isExcelExport: {
      type: Boolean,
      default: false,
    },
    headerbr: {
      type: Boolean,
      default: false,
    },
    isExcelImport: {
      type: Boolean,
      default: false,
    },
    columnSetting: {
      type: Boolean,
      default: false,
    },
    handleDisable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      handle: "操作",
      headerWidth: "100",
      routePush: this.$route.path,
    };
  },
  created() {
    if (getSession("LanguageName") == "en") {
      this.handle = "operation";
    }
  },
  computed: {
    handleBT() {
      let vnode = [];
      if (this.$route.path == "/CW/sdrl_edit") {
        let editcount = 0;
        for (let i = 0; i < this.$parent.$parent.handleBtn.length; i++) {
          if (this.$parent.$parent.handleBtn[i].key == "edit") {
            editcount++;
          }
        }
        if (editcount === 0) {
          vnode.push({
            class: "el-icon-edit",
            key: "edit",
            title: this.$t("configMoudle.edit"),
          });
        }
        let deletecount = 0;
        for (let i = 0; i < this.$parent.$parent.handleBtn.length; i++) {
          if (this.$parent.$parent.handleBtn[i].key == "delete") {
            deletecount++;
          }
        }
        if (deletecount === 0) {
          vnode.push({
            class: "el-icon-delete",
            key: "delete",
            title: this.$t("configMoudle.delete"),
          });
        }
      }
      if (this.handleDisable) {
        let viewcount = 0;
        for (let i = 0; i < this.$parent.$parent.handleBtn.length; i++) {
          if (this.$parent.$parent.handleBtn[i].key == "view") {
            viewcount++;
          }
        }
        if (viewcount === 0 && this.$route.path !== "/zcyhgl/ccyhsp" && this.$route.path !== "/gpgl/myBusiness") {
          vnode.push({
            class: "el-icon-view",
            key: "view",
            title: this.$t("configMoudle.view"),
          });
        }
      }

      if (this.$route.path == "/gpgl/wdgp") {
        let confirmedListing = 0;
        for (let i = 0; i < this.$parent.$parent.handleBtn.length; i++) {
          if (this.$parent.$parent.handleBtn[i].key == "confirmedListing")
            confirmedListing++;
        }
        if (confirmedListing === 0) {
          vnode.push({
            class: "el-icon-success",
            key: "confirmedListing",
            title: "挂牌",
          });
        }

        let cancelListing = 0;
        for (let i = 0; i < this.$parent.$parent.handleBtn.length; i++) {
          if (this.$parent.$parent.handleBtn[i].key == "cancelListing") cancelListing++;
        }
        if (cancelListing === 0) {
          vnode.push({ class: "el-icon-error", key: "cancelListing", title: "取消挂牌" });
        }
      }

      if (this.$route.path == "/gpgl/wdzp") {
        let delistedModuleListed = 0;
        for (let i = 0; i < this.$parent.$parent.handleBtn.length; i++) {
          if (this.$parent.$parent.handleBtn[i].key == "delistedModuleListed")
            delistedModuleListed++;
        }
        if (delistedModuleListed === 0) {
          // vnode.push({
          //   class: "el-icon-success",
          //   key: "delistedModuleListed",
          //   title: "挂牌",
          // });
        }

        let cancelDelisting = 0;
        for (let i = 0; i < this.$parent.$parent.handleBtn.length; i++) {
          if (this.$parent.$parent.handleBtn[i].key == "cancelDelisting")
            cancelDelisting++;
        }
        if (cancelDelisting === 0) {
          vnode.push({
            class: "el-icon-error",
            key: "cancelDelisting",
            title: "取消摘牌",
          });
        }
      }

      if (this.$route.path == "/gpgl/gpdt") {
        let confirmedDelisting = 0;
        for (let i = 0; i < this.$parent.$parent.handleBtn.length; i++) {
          if (this.$parent.$parent.handleBtn[i].key == "confirmedDelisting")
            confirmedDelisting++;
        }
        if (confirmedDelisting === 0) {
          vnode.push({
            class: "el-icon-success",
            key: "confirmedDelisting",
            title: "摘牌",
          });
        }
      }

      if (this.$route.path == "/gpgl/jywj") {
        let completed = 0;
        for (let i = 0; i < this.$parent.$parent.handleBtn.length; i++) {
          if (this.$parent.$parent.handleBtn[i].key == "completed") completed++;
        }
        if (completed === 0) {
          vnode.push({ class: "el-icon-success", key: "completed", title: "完成" });
        }

        let closingManagement = 0;
        for (let i = 0; i < this.$parent.$parent.handleBtn.length; i++) {
          if (this.$parent.$parent.handleBtn[i].key == "closingManagement") closingManagement++;
        }
        if (closingManagement === 0) {
          vnode.push({ class: "el-icon-set-up", key: "closingManagement", title: "流程" });

        }
      }
      return vnode.concat(this.$parent.$parent.handleBtn);
    },
  },
  mounted() { },
};
</script>

<style scoped lang="scss">
.dot-item {
  width: 16px;
  height: 16px;
}
</style>
